export default {
  date: 'YYYY-MM-DD',
  time: 'HH:mm:ss',
  hourMin: 'HH:mm',
  dateTime: 'YYYY-MM-DD HH:mm:ss',
  dateHourMin: 'YYYY-MM-DD HH:mm',
  dateYearMonth: 'YYYY-MM',
};
